import { render, staticRenderFns } from "./ProductPromotion.vue?vue&type=template&id=c39a61f4&scoped=true"
import script from "./ProductPromotion.vue?vue&type=script&lang=js"
export * from "./ProductPromotion.vue?vue&type=script&lang=js"
import style0 from "./ProductPromotion.vue?vue&type=style&index=0&id=c39a61f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39a61f4",
  null
  
)

export default component.exports